var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_173_34)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 39.653,
    cy: 37.3112,
    r: 25.3112,
    fill: "url(#paint0_radial_173_34)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.653,
    cy: 37.3112,
    r: 24.4483,
    stroke: "white",
    strokeWidth: 1.72576
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5698 38.2973H40.6391V43.2281C40.6391 43.7704 40.1953 44.2142 39.6529 44.2142C39.1105 44.2142 38.6668 43.7704 38.6668 43.2281V38.2973H33.736C33.1936 38.2973 32.7499 37.8535 32.7499 37.3112C32.7499 36.7688 33.1936 36.325 33.736 36.325H38.6668V31.3943C38.6668 30.8519 39.1105 30.4081 39.6529 30.4081C40.1953 30.4081 40.6391 30.8519 40.6391 31.3943V36.325H45.5698C46.1122 36.325 46.556 36.7688 46.556 37.3112C46.556 37.8535 46.1122 38.2973 45.5698 38.2973Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_173_34",
    x: 0.535707,
    y: 0.494925,
    width: 78.2345,
    height: 78.2345,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.30102
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.90305
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_173_34"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_173_34",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_173_34",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.653 37.3112) rotate(90) scale(25.3112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62A6B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#367B8D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.c58470fdc9c64e85719d715a1694d4aa.svg";
export { ForwardRef as ReactComponent };